/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { GetTraceabilityCampaignStatsQueryResponse } from "../types/GetTraceabilityCampaignStats.ts"

export const getTraceabilityCampaignStatsQueryKey = () =>
  [{ url: "/v1/product/get-traceability-campaign-stats" }] as const

export type GetTraceabilityCampaignStatsQueryKey = ReturnType<
  typeof getTraceabilityCampaignStatsQueryKey
>

/**
 * @summary Get traceability campaign stats
 * {@link /v1/product/get-traceability-campaign-stats}
 */
export async function getTraceabilityCampaignStats(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetTraceabilityCampaignStatsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/get-traceability-campaign-stats`,
    ...requestConfig,
  })
  return res
}

export function getTraceabilityCampaignStatsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = getTraceabilityCampaignStatsQueryKey()
  return queryOptions<
    ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getTraceabilityCampaignStats(config)
    },
  })
}

/**
 * @summary Get traceability campaign stats
 * {@link /v1/product/get-traceability-campaign-stats}
 */
export function useGetTraceabilityCampaignStats<
  TData = ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
  TQueryData = ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
  TQueryKey extends QueryKey = GetTraceabilityCampaignStatsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTraceabilityCampaignStatsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? getTraceabilityCampaignStatsQueryKey()

  const query = useQuery(
    {
      ...getTraceabilityCampaignStatsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
